/**
 * Takes in a phone number, and based on user's timezone returns a re-formatted number
 *
 * @param {String} phoneNumber , phone number.
 * @param {String} userTimezone , user's timezone
 * @returns {String} The re-formatted phone number
 */
export const formatInternationalPhoneNumber = (phoneNumber, userTimezone) => {
  if (phoneNumber == null) return null;
  const AUSTRALIA = 'australia';
  const AU_PHONE_CODE = '+61';
  const plusSignRegex = /\+/;
  const phoneNumberToFormat = phoneNumber.replace(/\s+/g, '').replace(/^0+/, '');
  // If number already starts with +, this will return the same number received.
  if (plusSignRegex.test(phoneNumberToFormat)) {
    return phoneNumberToFormat;
  }
  // If user not in AU, return the same value.
  if (!userTimezone.trim().toLowerCase().includes(AUSTRALIA)) {
    return phoneNumber;
  }
  // Validating if phonumber starts with 4 to be re-formatted
  const regexAustralia = /^4\d{8}$/;
  if (regexAustralia.test(phoneNumberToFormat)) {
    return `${AU_PHONE_CODE}${phoneNumberToFormat}`;
  }

  return phoneNumber;
};
